import React from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { PromoCode } from "../../../../APIs/promoCode";

interface PromoCodeTableProps {
  promoCodes: PromoCode[];
  loading: boolean;
  onEditPromoCode: (promoCode: PromoCode) => void;
  currentPage: number;
  pageNumbers: any[];
  currentProducts: PromoCode[];
  handlePageChange: (e: any) => void;
  handleDeletePromoCode: (promoCodeId: number) => void;
}
const PromoCodeTable: React.FC<PromoCodeTableProps> = ({
  promoCodes,
  loading,
  onEditPromoCode,
  currentPage,
  pageNumbers,
  handlePageChange,
  handleDeletePromoCode,
  currentProducts,
}) => {
  const handleEditOrder = (order: PromoCode) => {
    onEditPromoCode(order);
  };
  const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) {
      return "Invalid date";
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid date";
    }
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      day: "numeric",
      year: "numeric",
      month: "long",
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  const formatCodeValue = (value: string, type: string): string => {
    if (type === "percentage") {
      const numValue = parseFloat(value);
      return `${numValue}%`;
    } else if (type === "decimal") {
      return `R ${value}`;
    }
    return value;
  };

  const isExpired = (dateString: string | null | undefined): boolean => {
    if (!dateString) return false;
    const currentDate = new Date();
    const expiredDate = new Date(dateString);
    return expiredDate < currentDate;
  };

  return (
    <div className="flex flex-col text-black">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
          <div className="overflow-hidden  rounded-lg">
            <table className="min-w-full text-sm">
              <thead className="text-xs text-gray-700  dark:text-gray-400">
                <tr className="bg-gray-100 text-black text-[16px] h-[65px]">
                  <th scope="col" className="p-3">
                    Code Name
                  </th>
                  <th scope="col" className="p-3">
                    Code Value
                  </th>
                  <th scope="col" className="p-3">
                    Code Type
                  </th>
                  <th scope="col" className="p-3">
                    Max limit
                  </th>
                  <th scope="col" className="p-3">
                    Number of users
                  </th>
                  <th scope="col" className="p-3">
                    Expired Date
                  </th>
                  <th scope="col" className="p-3">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="text-blue">
                {loading ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  currentProducts.map((product) => (
                    <tr
                      key={product.id}
                      className="hover:bg-gray-100 transition duration-200 text-[#75A7AD]">
                      {/* <td className="border-b p-3">{product.description}</td> */}

                      <td className="border-b p-3 font-semibold text-black">
                        {product.code}
                      </td>
                      <td className="border-b p-3">
                        {formatCodeValue(product.code_value, product.code_type)}
                      </td>
                      <td className="border-b p-3">{product.code_type}</td>
                      <td className="border-b p-3">{product.max_count}</td>
                      <td className="border-b p-3">{product.used_count}</td>
                      {/* <td className="border-b p-3">
                        {formatDate(product.expired_date || "")}
                      </td> */}
                      <td className="border-b p-3">
                        <div className="flex items-center space-x-2">
                          <span>{formatDate(product.expired_date || "")}</span>
                          {isExpired(product.expired_date) && (
                            <span className="px-2 py-1 text-xs font-semibold text-red-800 bg-red-200 rounded-full">
                              Expired
                            </span>
                          )}
                        </div>
                      </td>

                      <td className="border-b p-3">
                        <div className="flex items-center space-x-4">
                          <span
                            onClick={() => handleEditOrder(product)}
                            className="text-[#75A7AD] cursor-pointer hover:text-gray-800 
                          flex items-center"
                            title="Edit Order">
                            <EditOutlined className="mr-1" />
                            Edit
                          </span>
                          <span
                            onClick={() => handleDeletePromoCode(product.id)}
                            className="text-[#FF6347] cursor-pointer hover:text-gray-800 flex items-center"
                            title="Delete Order">
                            <DeleteOutlined className="mr-1" />
                            Delete
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="flex space-x-4 mt-[20px] justify-end">
        <section className=" inline-flex col row">
          <div className="flex">
            {currentPage > 1 && (
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                className="rounded-full h-8 px-1 font-semibol bg-white  ml-[10px]">
                <BiChevronLeft size={30} className="text-black" />
              </button>
            )}

            {pageNumbers.map(
              (number, index) =>
                // Display only the relevant buttons for the current page
                currentPage <= index + 2 &&
                index + 1 <= currentPage + 2 && (
                  <div className="flex space-x-3" key={number}>
                    {<div></div>}
                    <button
                      className="rounded-full h-8 px-3 font-semibol text-white "
                      onClick={() => handlePageChange(number)}
                      style={{
                        backgroundColor:
                          number === currentPage ? "#75A7AD" : "white",
                        color: number === currentPage ? "white" : "black",
                      }}>
                      {number}
                    </button>
                  </div>
                )
            )}

            {currentPage < pageNumbers.length && (
              <button
                className="rounded-full h-8 px-1 font-semibol bg-white  ml-[10px]"
                onClick={() => handlePageChange(currentPage + 1)}>
                <BiChevronRight size={30} className="text-black " />
              </button>
            )}
          </div>
        </section>
        <section className=" flex space-x-8  p-2">
          <h5 className="font-bold text-black text-xs mr-[-20px]">
            Product per page
          </h5>
          <select
            id="role"
            className="mt-[-8px] w-[90px] py-2  block rounded-md focus:outline-none text-black text-sm bg-white"
            name="role"
            value={currentPage}
            onChange={(e) => handlePageChange(Number(e.target.value))}>
            {pageNumbers.map((option: number) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </section>
      </div>
    </div>
  );
};

export default PromoCodeTable;
